import { useMutation } from 'react-query';
import axiosInstance from '../axiosInstance';
import { useDispatch } from 'react-redux';
import { setLoading } from 'Actions/LoadingActions';
import { useEffect } from 'react';

const DEBUG = import.meta.env.DEV;

export const useMutationQuery = ({ method, url, options = {}, needLoading = true }) => {
  const dispatch = useDispatch();
  const mutation = useMutation(
    async data => {
      if (DEBUG) {
        console.log(`${method.toUpperCase()} ${url}`, data);
      }
      const response = await axiosInstance({
        method,
        url,
        data,
      });
      if (response.data.success === false) {
        if (DEBUG) console.error(`${method.toUpperCase()} 요청 중 에러 발생:`, response.data.err);
        throw new Error(response.data.err);
      }
      if (DEBUG) {
        console.log(`[${method.toUpperCase()}]`, response.data);
      }
      return response.data;
    },
    {
      onError: error => {
        if (DEBUG) console.error(`${method.toUpperCase()} 요청 중 에러 발생:`, error);
      },
      ...options,
    }
  );

  useEffect(() => {
    if (!needLoading) return;
    if (mutation.isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
    return () => {
      dispatch(setLoading(false));
    };
  }, [mutation.isLoading, dispatch, needLoading]);

  return mutation;
};
